import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ForActive, Logo, Phone } from "../constant/Index";
import { useSiteContentQuery } from "../store/services/SitesettingService";
import { useEffect } from "react";

const Header = () => {
	const { data, isLoading } = useSiteContentQuery();
	let response = data?.response?.data[0];
	let currentUrl = window.location.href.split("/");
	const [open, setOpen] = useState(false);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])
	return (
		<>
			{/* Header Sec Start Here */}
			<header
				id="headerTop"
				className={`${currentUrl?.[3] === "" ? "active" : null}`}
			>
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-2 col-5">
							<div className="logoBox">
								<Link to="/">
									<figure>
										<img
											src={response?.logo_path}
											alt=""
											className="img-fluid"
										/>
									</figure>
								</Link>
							</div>
						</div>
						<div className="col-lg-7 col-1">
							<div className="menu-bar">
								<ul className="menus">
									<li
										className={`${currentUrl?.[3] === ""
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/">HOME</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									<li
										className={`${currentUrl?.[3] === "about"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/about">ABOUT</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									<li
										className={`${currentUrl?.[3] === "explore"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/explore">NFTs Levels</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									{/* <li
										className={`${
											currentUrl?.[3] === "roadmap"
												? "menu-items active"
												: "menu-items"
										}`}
									>
										<Link to="/roadmap">ROADMAP</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li> */}
									<li
										className={`${currentUrl?.[3] === "faqs"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/faqs">FAQS</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									<li
										className={`${currentUrl?.[3] === "community"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/community">COMMUNITY</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									<li
										className={`${currentUrl?.[3] === "roadmap"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/roadmap">Road map</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
									<li
										className={`${currentUrl?.[3] === "contact"
											? "menu-items active"
											: "menu-items"
											}`}
									>
										<Link to="/contact">CONTACT US</Link>
										<img src={ForActive} alt="" className="img-fluid" />
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-3 col-5">
							<div className="right-side">
								{/* <div className="search-btn">
									<button
										type="button"
										className="btn btn-primary"
										data-bs-toggle="modal"
										data-bs-target="#searchBox"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="21.797"
											height="21.809"
											viewBox="0 0 21.797 21.809"
										>
											<path
												id="Path_18399"
												data-name="Path 18399"
												d="M1080.4-695.021a10.111,10.111,0,0,1-14.159-1.485,10.082,10.082,0,0,1,.474-13.318,10.058,10.058,0,0,1,13.393-1.153,9.81,9.81,0,0,1,3.969,6.805,9.984,9.984,0,0,1-2.166,7.631,1.676,1.676,0,0,1,.268.179c1.3,1.294,1.883,1.881,3.182,3.175a1.143,1.143,0,0,1,.37,1.094,1.121,1.121,0,0,1-1.836.618c-.113-.1-.215-.207-.32-.312-1.241-1.24-1.772-1.769-3.01-3.011A1.756,1.756,0,0,1,1080.4-695.021Zm1.519-7.866a7.842,7.842,0,0,0-7.826-7.865,7.84,7.84,0,0,0-7.895,7.821,7.86,7.86,0,0,0,7.851,7.9A7.862,7.862,0,0,0,1081.923-702.887Z"
												transform="translate(-1063.962 713.006)"
												fill="#fff"
											/>
										</svg>
									</button>
								</div> */}
								<div className="phone-number">
									<div className="icon">
										<figure>
											<img src={Phone} alt="" className="img-fluid" />
										</figure>
									</div>
									<div className="txt">
										<span>PHONE NUMBER</span>
										<br />
										<a href={"tel:" + response?.contact_phone}>
											{response?.contact_phone}
										</a>
									</div>
								</div>
								<div className="canvas-bar">
									<button onClick={() => setOpen(true)}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="9.454"
											height="22.219"
											viewBox="0 0 9.454 22.219"
										>
											<g
												id="Group_8909"
												data-name="Group 8909"
												transform="translate(-33.384 -31.501)"
											>
												<path
													id="Path_60"
													data-name="Path 60"
													d="M558.787,170.747a4.032,4.032,0,0,1,.252-.553.743.743,0,0,1,.67-.344h1.119c4.769,0,6.539,0,11.308,0a1.151,1.151,0,0,1,.433.071,1.13,1.13,0,0,1,.577,1.148,1.02,1.02,0,0,1-.74.985,1.643,1.643,0,0,1-.287.02c-5.08,0-7.16,0-12.24.007a1.02,1.02,0,0,1-1.091-.9Z"
													transform="translate(212.688 -527.286) rotate(90)"
													fill="#fff"
												/>
												<path
													id="Path_62"
													data-name="Path 62"
													d="M556.787,36.613a1.166,1.166,0,0,1,.956-.889,1.674,1.674,0,0,1,.259-.016h19.786a1.118,1.118,0,0,1,1.176,1.405,1.091,1.091,0,0,1-.988.81c-.1.007-.2.006-.3.006q-9.741,0-19.482.008a1.278,1.278,0,0,1-1.4-.89Z"
													transform="translate(71.322 -525.286) rotate(90)"
													fill="#fff"
												/>
											</g>
										</svg>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
			{/* Header Sec End Here */}

			{/* Vertical Sec Start Here */}
			<div className="vertical-left-bar">
				<div className="canvas-bar">
					<button onClick={() => setOpen(true)}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="9.454"
							height="22.219"
							viewBox="0 0 9.454 22.219"
						>
							<g
								id="Group_8909"
								data-name="Group 8909"
								transform="translate(-33.384 -31.501)"
							>
								<path
									id="Path_60"
									data-name="Path 60"
									d="M558.787,170.747a4.032,4.032,0,0,1,.252-.553.743.743,0,0,1,.67-.344h1.119c4.769,0,6.539,0,11.308,0a1.151,1.151,0,0,1,.433.071,1.13,1.13,0,0,1,.577,1.148,1.02,1.02,0,0,1-.74.985,1.643,1.643,0,0,1-.287.02c-5.08,0-7.16,0-12.24.007a1.02,1.02,0,0,1-1.091-.9Z"
									transform="translate(212.688 -527.286) rotate(90)"
									fill="#fff"
								/>
								<path
									id="Path_62"
									data-name="Path 62"
									d="M556.787,36.613a1.166,1.166,0,0,1,.956-.889,1.674,1.674,0,0,1,.259-.016h19.786a1.118,1.118,0,0,1,1.176,1.405,1.091,1.091,0,0,1-.988.81c-.1.007-.2.006-.3.006q-9.741,0-19.482.008a1.278,1.278,0,0,1-1.4-.89Z"
									transform="translate(71.322 -525.286) rotate(90)"
									fill="#fff"
								/>
							</g>
						</svg>
					</button>
				</div>
				<div className="social-elements">
					<ul className="socials">
						<li>
							<a href={response?.instagram}>INSTAGRAM</a>
						</li>
						<li>
							<a href={response?.twitter}>TWITTER</a>
						</li>
						<li>
							<a href={response?.facebook}>FACEBOOK</a>
						</li>
					</ul>
				</div>
				<div
					className={`${currentUrl?.[3] === "/" ? "scroll-now" : "scroll-now active"
						}`}
				>
					<div className="txt"> SCROLL NOW</div>
					<div className="icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="23"
							height="23"
							viewBox="0 0 23 23"
						>
							<g
								id="Group_35"
								data-name="Group 35"
								transform="translate(216 -891)"
							>
								<g
									id="Group_34"
									data-name="Group 34"
									transform="translate(-216 891)"
								>
									<g
										id="Group_10"
										data-name="Group 10"
										transform="translate(0)"
									>
										<g
											id="Ellipse_1"
											data-name="Ellipse 1"
											fill="none"
											stroke="rgba(255,255,255,0.3)"
											strokeWidth="2"
										>
											<circle cx="11.5" cy="11.5" r="11.5" stroke="none" />
											<circle cx="11.5" cy="11.5" r="10.5" fill="none" />
										</g>
										<g
											id="Path_65"
											data-name="Path 65"
											fill="none"
											strokeDasharray="56"
										>
											<path
												d="M11.5,0A11.5,11.5,0,1,1,0,11.5,11.5,11.5,0,0,1,11.5,0Z"
												stroke="none"
											/>
											<path
												d="M 11.5 0 C 17.85127067565918 0 23 5.14872932434082 23 11.5 C 23 17.85127067565918 17.85127067565918 23 11.5 23 C 5.14872932434082 23 0 17.85127067565918 0 11.5 C 0 11.49728679656982 1.9073486328125e-06 11.49434089660645 3.814697265625e-06 11.49162769317627 C 3.814697265625e-06 11.4907341003418 5.7220458984375e-06 11.48986148834229 5.7220458984375e-06 11.48896789550781 C 7.62939453125e-06 11.4866418838501 9.5367431640625e-06 11.48533153533936 1.33514404296875e-05 11.48300647735596 C 1.33514404296875e-05 11.48207569122314 1.52587890625e-05 11.48114776611328 1.71661376953125e-05 11.48021602630615 C 2.09808349609375e-05 11.47789192199707 2.47955322265625e-05 11.47551918029785 3.0517578125e-05 11.47319507598877 C 3.24249267578125e-05 11.47274780273438 3.24249267578125e-05 11.47229957580566 3.4332275390625e-05 11.47185325622559 C 4.00543212890625e-05 11.46914100646973 4.9591064453125e-05 11.46615123748779 5.7220458984375e-05 11.46343994140625 C 5.91278076171875e-05 11.4626579284668 6.29425048828125e-05 11.46186542510986 6.4849853515625e-05 11.46108341217041 C 7.2479248046875e-05 11.45875930786133 7.82012939453125e-05 11.45721435546875 8.7738037109375e-05 11.45489025115967 C 8.96453857421875e-05 11.45399761199951 9.5367431640625e-05 11.45303153991699 9.72747802734375e-05 11.45213794708252 C 0.0001068115234375 11.44981479644775 0.0001163482666015625 11.44796466827393 0.000125885009765625 11.44564151763916 C 0.00012969970703125 11.44500827789307 0.0001316070556640625 11.44435691833496 0.0001354217529296875 11.44372463226318 C 0.0001506805419921875 11.4406270980835 0.0001621246337890625 11.43829250335693 0.000179290771484375 11.43519496917725 C 0.0001811981201171875 11.43471145629883 0.0001850128173828125 11.43423748016357 0.000186920166015625 11.43375396728516 C 0.0002002716064453125 11.43143177032471 0.000213623046875 11.42913150787354 0.0002288818359375 11.42680931091309 C 0.0002346038818359375 11.42587947845459 0.000240325927734375 11.4249439239502 0.0002460479736328125 11.4240140914917 C 0.0002613067626953125 11.42169189453125 0.000270843505859375 11.42033863067627 0.000286102294921875 11.41801738739014 C 0.0002918243408203125 11.41716194152832 0.00029754638671875 11.41634654998779 0.00030517578125 11.41549110412598 C 0.000324249267578125 11.41278171539307 0.0003452301025390625 11.40980339050293 0.0003681182861328125 11.40709495544434 C 0.0003681182861328125 11.40698337554932 0.000370025634765625 11.4068489074707 0.000370025634765625 11.40673732757568 C 0.0003910064697265625 11.40402889251709 0.0004138946533203125 11.40137195587158 0.0004367828369140625 11.39866352081299 C 0.0004444122314453125 11.39780902862549 0.0004520416259765625 11.3969259262085 0.0004596710205078125 11.396071434021 C 0.00048065185546875 11.39375019073486 0.000492095947265625 11.39246654510498 0.000514984130859375 11.39014625549316 C 0.000522613525390625 11.38917922973633 0.0005321502685546875 11.38827228546143 0.00054168701171875 11.38730525970459 C 0.0005626678466796875 11.38498497009277 0.000583648681640625 11.38290786743164 0.0006084442138671875 11.38058757781982 C 0.000614166259765625 11.38002967834473 0.0006198883056640625 11.37943553924561 0.0006256103515625 11.37887859344482 C 0.000652313232421875 11.37617111206055 0.000682830810546875 11.37336730957031 0.000713348388671875 11.37066078186035 C 0.0007228851318359375 11.36976909637451 0.0007343292236328125 11.36881923675537 0.000743865966796875 11.36792755126953 C 0.0007648468017578125 11.36599445343018 0.00078582763671875 11.36419296264648 0.0008087158203125 11.36225986480713 C 0.0008220672607421875 11.36118221282959 0.0008335113525390625 11.36014175415039 0.00084686279296875 11.35906410217285 C 0.0008697509765625 11.3571310043335 0.000888824462890625 11.3556079864502 0.000911712646484375 11.35367488861084 C 0.0009250640869140625 11.35259819030762 0.00093841552734375 11.35158252716064 0.0009517669677734375 11.35050487518311 C 0.0009860992431640625 11.34779930114746 0.001018524169921875 11.34531402587891 0.001054763793945312 11.34260940551758 C 0.001068115234375 11.34171772003174 0.001079559326171875 11.34083271026611 0.00109100341796875 11.33994102478027 C 0.001117706298828125 11.33800888061523 0.001142501831054688 11.33627796173096 0.001169204711914062 11.33434581756592 C 0.001186370849609375 11.33319568634033 0.001201629638671875 11.3320255279541 0.001218795776367188 11.3308744430542 C 0.001241683959960938 11.32932949066162 0.001272201538085938 11.32726860046387 0.001295089721679688 11.32572364807129 C 0.001310348510742188 11.32460975646973 0.0013275146484375 11.32352161407471 0.001344680786132812 11.32240867614746 C 0.001379013061523438 11.32009124755859 0.001407623291015625 11.31822299957275 0.001443862915039062 11.3159065246582 C 0.001462936401367188 11.31471824645996 0.001482009887695312 11.313551902771 0.001501083374023438 11.31236457824707 C 0.001531600952148438 11.31043338775635 0.001569747924804688 11.30810737609863 0.001600265502929688 11.30617713928223 C 0.001619338989257812 11.30510139465332 0.001636505126953125 11.30399417877197 0.00165557861328125 11.30291843414307 C 0.001682281494140625 11.3013744354248 0.001714706420898438 11.2993803024292 0.001741409301757812 11.29783630371094 C 0.00176239013671875 11.29664897918701 0.001783370971679688 11.2954158782959 0.001804351806640625 11.29422950744629 C 0.00183868408203125 11.29229927062988 0.001871109008789062 11.2905101776123 0.001905441284179688 11.2885799407959 C 0.001920700073242188 11.28776359558105 0.001935958862304688 11.28688144683838 0.001951217651367188 11.28606510162354 C 0.0019989013671875 11.28336334228516 0.002044677734375 11.28091335296631 0.002096176147460938 11.27821159362793 C 0.002117156982421875 11.277099609375 0.002140045166015625 11.27596664428711 0.002161026000976562 11.27485370635986 C 0.002197265625 11.27292442321777 0.002223968505859375 11.27159118652344 0.002262115478515625 11.26966190338135 C 0.002283096313476562 11.2685489654541 0.002305984497070312 11.26742649078369 0.00232696533203125 11.26631450653076 C 0.002367019653320312 11.26438522338867 0.0023956298828125 11.26292419433594 0.002435684204101562 11.26099586486816 C 0.0024566650390625 11.2599573135376 0.002475738525390625 11.25895214080811 0.002498626708984375 11.25791358947754 C 0.002546310424804688 11.25559997558594 0.002613067626953125 11.25243854522705 0.002660751342773438 11.25012397766113 C 0.002683639526367188 11.24904918670654 0.002710342407226562 11.24789905548096 0.002733230590820312 11.24682426452637 C 0.002775192260742188 11.24489593505859 0.002798080444335938 11.24380970001221 0.002840042114257812 11.24188137054443 C 0.00286865234375 11.24058532714844 0.002899169921875 11.23925018310547 0.002927780151367188 11.23795318603516 C 0.002962112426757812 11.23641109466553 0.002992630004882812 11.23505115509033 0.003026962280273438 11.2335090637207 C 0.003055572509765625 11.23224925994873 0.003086090087890625 11.23095035552979 0.003114700317382812 11.22969055175781 C 0.0031585693359375 11.22776317596436 0.0031890869140625 11.22647380828857 0.00323486328125 11.22454643249512 C 0.003282546997070312 11.2225456237793 0.003332138061523438 11.22046184539795 0.00337982177734375 11.21846199035645 C 0.003416061401367188 11.21691989898682 0.003450393676757812 11.21548271179199 0.003488540649414062 11.21394062042236 C 0.0035247802734375 11.21245956420898 0.003561019897460938 11.21103286743164 0.003597259521484375 11.20955181121826 C 0.003635406494140625 11.20801067352295 0.0036468505859375 11.20756435394287 0.00368499755859375 11.20602321624756 C 0.003725051879882812 11.20443153381348 0.003765106201171875 11.20284652709961 0.003805160522460938 11.20125389099121 C 0.003835678100585938 11.20009803771973 0.003864288330078125 11.19897747039795 0.003894805908203125 11.19782161712646 C 0.003963470458984375 11.19515609741211 0.004032135009765625 11.19251251220703 0.004102706909179688 11.18984699249268 C 0.004133224487304688 11.18869209289551 0.00417327880859375 11.18715286254883 0.00420379638671875 11.18599796295166 C 0.004245758056640625 11.18447971343994 0.0042877197265625 11.18294048309326 0.004327774047851562 11.18142318725586 C 0.004360198974609375 11.18026733398438 0.00439453125 11.17898845672607 0.004426956176757812 11.17783260345459 C 0.004468917846679688 11.17631530761719 0.004510879516601562 11.17477703094482 0.004552841186523438 11.17326068878174 C 0.00458526611328125 11.17210483551025 0.004619598388671875 11.17092323303223 0.004652023315429688 11.16976833343506 C 0.00475311279296875 11.16614246368408 0.004856109619140625 11.16252326965332 0.004962921142578125 11.15889835357666 C 0.004974365234375 11.15851306915283 0.004980087280273438 11.1582670211792 0.004991531372070312 11.15788269042969 C 0.005037307739257812 11.15632915496826 0.005083084106445312 11.15479183197021 0.005128860473632812 11.15323829650879 C 0.005163192749023438 11.15208435058594 0.005191802978515625 11.15108776092529 0.005228042602539062 11.14993286132812 C 0.005277633666992188 11.148268699646 0.005327224731445312 11.14660930633545 0.005376815795898438 11.14494514465332 C 0.005413055419921875 11.14379119873047 0.00543212890625 11.14314651489258 0.005468368530273438 11.14199256896973 C 0.005521774291992188 11.14021682739258 0.005573272705078125 11.13851547241211 0.005628585815429688 11.13674068450928 C 0.005641937255859375 11.13635540008545 0.0056610107421875 11.13574504852295 0.005672454833984375 11.13536071777344 C 0.005792617797851562 11.13151550292969 0.00591278076171875 11.12769889831543 0.006036758422851562 11.123854637146 C 0.006048202514648438 11.12346935272217 0.00608062744140625 11.12246799468994 0.006093978881835938 11.12208271026611 C 0.006153106689453125 11.12023448944092 0.006212234497070312 11.11839199066162 0.006273269653320312 11.11654376983643 C 0.006298065185546875 11.1157751083374 0.006326675415039062 11.11490535736084 0.006353378295898438 11.1141357421875 C 0.006414413452148438 11.11225128173828 0.006473541259765625 11.1104564666748 0.006536483764648438 11.10857200622559 C 0.006563186645507812 11.10780239105225 0.006572723388671875 11.10751438140869 0.00659942626953125 11.10674476623535 C 0.006805419921875 11.10061168670654 0.007017135620117188 11.09444522857666 0.007232666015625 11.08831405639648 C 0.007259368896484375 11.08754539489746 0.00728607177734375 11.08677768707275 0.007314682006835938 11.08600902557373 C 0.007379531860351562 11.08416271209717 0.007444381713867188 11.08231830596924 0.007511138916015625 11.08047199249268 C 0.007537841796875 11.07970333099365 0.007556915283203125 11.07922554016113 0.0075836181640625 11.07845687866211 C 0.007810592651367188 11.07217884063721 0.008039474487304688 11.06594848632812 0.008275985717773438 11.05967330932617 C 0.008304595947265625 11.05890560150146 0.008304595947265625 11.05888652801514 0.008333206176757812 11.05811786651611 C 0.008409500122070312 11.05612468719482 0.00848388671875 11.05417060852051 0.0085601806640625 11.05217742919922 C 0.008575439453125 11.05179309844971 0.008611679077148438 11.05081844329834 0.008626937866210938 11.05043506622314 C 0.008882522583007812 11.04379177093506 0.0091400146484375 11.03722286224365 0.00940704345703125 11.03058338165283 C 0.00940704345703125 11.03058338165283 0.009424209594726562 11.03013706207275 0.009424209594726562 11.03013706207275 C 0.009510040283203125 11.02803421020508 0.0095977783203125 11.02585792541504 0.009683609008789062 11.02375602722168 C 0.009698867797851562 11.02337169647217 0.009716033935546875 11.02296257019043 0.009731292724609375 11.02257823944092 C 0.01010704040527344 11.0133581161499 0.01049423217773438 11.00414371490479 0.01089286804199219 10.99492931365967 C 0.01089286804199219 10.99492931365967 0.01090049743652344 10.9947566986084 0.01090049743652344 10.9947566986084 C 0.02976799011230469 10.55838012695312 0.07295799255371094 10.12826347351074 0.1391391754150391 9.705820083618164 L 2.115030288696289 10.01537036895752 C 2.038700103759766 10.50259971618652 2 11.00209999084473 2 11.5 C 2 16.73831939697266 6.261680603027344 21 11.5 21 C 16.73831939697266 21 21 16.73831939697266 21 11.5 C 21 6.261680603027344 16.73831939697266 2 11.5 2 L 11.5 0 C 11.5 0 11.5 0 11.5 0 Z"
												stroke="none"
												fill="#fff"
											/>
										</g>
									</g>
									<path
										id="Path_64"
										data-name="Path 64"
										d="M.362,6.351A.479.479,0,0,1,0,5.864c0-.041,0-.083,0-.124Q0,3.176,0,.612A1.064,1.064,0,0,1,.046.289.387.387,0,0,1,.567.025,1.372,1.372,0,0,1,.916.192Q2.655,1.376,4.389,2.567a.858.858,0,0,1,.329.37.633.633,0,0,1-.169.718,1.377,1.377,0,0,1-.164.131L.918,6.159a1.167,1.167,0,0,1-.432.192Z"
										transform="translate(14.338 9.716) rotate(90)"
										fill="#f9f928"
									/>
								</g>
							</g>
						</svg>
					</div>
				</div>
			</div>
			{/* Vertical Sec End Here */}

			{/* <!-- Mobile Header Start Here --> */}
			<div className={open ? "mobile_header show" : "mobile_header"}>
				<div className="cancel" onClick={() => setOpen(false)}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="25"
						fill="#000"
						className="bi bi-x"
						viewBox="0 0 16 16"
					>
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
					</svg>
				</div>
				<ul className="mobile_menus">
					<li className="menu_items">
						<Link className="menu_links active_menu" to="/">
							HOME
						</Link>
					</li>
					<li className="menu_items">
						<Link className="menu_links" to="/about">
							ABOUT
						</Link>
					</li>
					<li className="menu_items">
						<Link className="menu_links" to="/explore">
							EXPLORE
						</Link>
					</li>
					<li className="menu_items">
						<Link className="menu_links" to="/roadmap">
							ROADMAP
						</Link>
					</li>
					<li className="menu_items">
						<Link className="menu_links" to="/community">
							Community
						</Link>
					</li>
					<li className="menu_items">
						<Link className="menu_links" to="/faqs">
							FAQS
						</Link>
					</li>
					{/* <li className="menu_items">
						<Link className="menu_links" to="/community">
							COMMUNITY
						</Link>
					</li> */}
					<li className="menu_items">
						<Link className="menu_links" to="/contact">
							CONTACT US
						</Link>
					</li>
					<li className="menu_items">
						<a className="menu_links" href="tel:123456789">
							123-(456)-789
						</a>
					</li>
				</ul>
			</div>
			{/* <!-- Mobile Header End Here --> */}

			{/* <!-- Search Start Here --> */}
			<div
				className="modal fade"
				id="searchBox"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="searchBoxLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<div className="search-bar">
							<div className="form-group">
								<input
									type="text"
									placeholder="Search..."
									className="form-control"
								/>
							</div>
							<button data-bs-dismiss="modal">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="21.797"
									height="21.809"
									viewBox="0 0 21.797 21.809"
								>
									<path
										id="Path_18399"
										data-name="Path 18399"
										d="M1080.4-695.021a10.111,10.111,0,0,1-14.159-1.485,10.082,10.082,0,0,1,.474-13.318,10.058,10.058,0,0,1,13.393-1.153,9.81,9.81,0,0,1,3.969,6.805,9.984,9.984,0,0,1-2.166,7.631,1.676,1.676,0,0,1,.268.179c1.3,1.294,1.883,1.881,3.182,3.175a1.143,1.143,0,0,1,.37,1.094,1.121,1.121,0,0,1-1.836.618c-.113-.1-.215-.207-.32-.312-1.241-1.24-1.772-1.769-3.01-3.011A1.756,1.756,0,0,1,1080.4-695.021Zm1.519-7.866a7.842,7.842,0,0,0-7.826-7.865,7.84,7.84,0,0,0-7.895,7.821,7.86,7.86,0,0,0,7.851,7.9A7.862,7.862,0,0,0,1081.923-702.887Z"
										transform="translate(-1063.962 713.006)"
										fill="#fff"
									/>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</div>
			{/* <!-- Search End Here --> */}
		</>
	);
};

export default Header;
